import React from 'react';
import {
  DotContainer,
  DraggableContainer,
  DraggableContainerProps,
} from './styled';

export default function Draggable({
  children = null,
  id,
  onDragOver,
  onDragStart,
  onDrop,
  draggable,
  ...rest
}: DraggableContainerProps) {
  return (
    <DraggableContainer
      id={id}
      onDragOver={onDragOver}
      onDragStart={onDragStart}
      onDrop={onDrop}
      draggable={draggable}
      {...rest}
    >
      <DotContainer>⋮⋮ </DotContainer>
      {children}
    </DraggableContainer>
  );
}
